export default __webpack_public_path__ + "static/media/addAcc.c95388c2.svg";